import React, { useState } from 'react';

const REGION_OPTIONS = {
  English: [
    { value: 'tamil', label: '🌴 Tamil Nadu Traditional' },
    { value: 'kerala', label: '🥥 Kerala Sadhya & Coastal' },
    { value: 'andhra', label: '🌶️ Andhra & Telangana Spicy' },
    { value: 'north', label: '🌾 North Indian & Punjabi' },
    { value: 'karnataka', label: '🫓 Karnataka & South Tiffin' },
    { value: 'global', label: '🥢 Indo-Chinese & Global' },
    { value: 'all', label: '🇮🇳 All India Balanced Fusion' }
  ],
  Tamil: [
    { value: 'tamil', label: '🌴 தமிழ்நாடு பாரம்பரியம்' },
    { value: 'kerala', label: '🥥 கேரளா பாரம்பரியம்' },
    { value: 'andhra', label: '🌶️ ஆந்திரா காரசார உணவு' },
    { value: 'north', label: '🌾 வட இந்தியா & பஞ்சாபி' },
    { value: 'karnataka', label: '🫓 கர்நாடகா & டிபன்' },
    { value: 'global', label: '🥢 இண்டோ-சைனீஸ் & சர்வதேசம்' },
    { value: 'all', label: '🇮🇳 அனைத்து மாநில கலவை' }
  ],
  Hindi: [
    { value: 'tamil', label: '🌴 तमिलनाडु पारंपरिक' },
    { value: 'kerala', label: '🥥 केरल पारंपरिक' },
    { value: 'andhra', label: '🌶️ आंध्र मसालेदार' },
    { value: 'north', label: '🌾 उत्तर भारत और पंजाबी' },
    { value: 'karnataka', label: '🫓 कर्नाटक व टिफिन' },
    { value: 'global', label: '🥢 इंडो-चाइनीज व ग्लोबल' },
    { value: 'all', label: '🇮🇳 सभी भारतीय राज्य' }
  ],
  Telugu: [
    { value: 'tamil', label: '🌴 తమిళనాడు సాంప్రదాయం' },
    { value: 'kerala', label: '🥥 కేరళ సాంప్రదాయం & సీఫుడ్' },
    { value: 'andhra', label: '🌶️ ఆంధ్ర & తెలంగాణ ఘాటైన వంటకాలు' },
    { value: 'north', label: '🌾 ఉత్తర భారతదేశం & పంజాబీ' },
    { value: 'karnataka', label: '🫓 కర్ణాటక టిఫిన్స్' },
    { value: 'global', label: '🥢 ఇండో-చైనీస్ & గ్లోబల్' },
    { value: 'all', label: '🇮🇳 అఖిల భారత సమతుల్య మెనూ' }
  ],
  Arabic: [
    { value: 'tamil', label: '🌴 مطبخ تاميل نادو التقليدي' },
    { value: 'kerala', label: '🥥 مطبخ كيرلا والمأكولات البحرية' },
    { value: 'andhra', label: '🌶️ مطبخ أندرا وتيلانجانا الحار' },
    { value: 'north', label: '🌾 شمال الهند والبنجاب' },
    { value: 'karnataka', label: '🫓 وجبات تيفين كارناتاكا' },
    { value: 'global', label: '🥢 المطبخ الهندي الصيني والعالمي' },
    { value: 'all', label: '🇮🇳 المطبخ الهندي الشامل المتوازن' }
  ]
};

const DIET_OPTIONS = {
  English: [
    { value: 'balanced', label: '🍛 Traditional Balanced' },
    { value: 'high_protein', label: '🥗 High Protein & Healthy Fiber' },
    { value: 'veg', label: '🥦 100% Pure Vegetarian' },
    { value: 'non_veg', label: '🍗 Non-Vegetarian Special' },
    { value: 'quick', label: '⚡ Quick 20-Min Meals' },
    { value: 'millets', label: '🥣 Healthy Millets & Low-GI' }
  ],
  Tamil: [
    { value: 'balanced', label: '🍛 சமச்சீர் அன்றாட உணவு' },
    { value: 'high_protein', label: '🥗 அதிக புரதம் & நார்ச்சத்து' },
    { value: 'veg', label: '🥦 100% சுத்த சைவ உணவு' },
    { value: 'non_veg', label: '🍗 அசைவ உணவுகள் ஸ்பெஷல்' },
    { value: 'quick', label: '⚡ சுலப 20 நிமிட சமையல்' },
    { value: 'millets', label: '🥣 சிறுதானிய சத்துணவு' }
  ],
  Hindi: [
    { value: 'balanced', label: '🍛 संतुलित दैनिक भोजन' },
    { value: 'high_protein', label: '🥗 उच्च प्रोटीन व फाइबर' },
    { value: 'veg', label: '🥦 100% शुद्ध शाकाहारी' },
    { value: 'non_veg', label: '🍗 मांसाहारी स्पेशल' },
    { value: 'quick', label: '⚡ 20 मिनट का त्वरित भोजन' },
    { value: 'millets', label: '🥣 पौष्टिक मिलेट्स व बाजरा' }
  ],
  Telugu: [
    { value: 'balanced', label: '🍛 సాంప్రదాయ సమతుల్య భోజనం' },
    { value: 'high_protein', label: '🥗 అధిక ప్రోటీన్ & ఫైబర్' },
    { value: 'veg', label: '🥦 100% స్వచ్ఛమైన శాకాహారం' },
    { value: 'non_veg', label: '🍗 నాన్-వెజ్ స్పెషల్' },
    { value: 'quick', label: '⚡ 20 నిమిషాల త్వరిత వంట' },
    { value: 'millets', label: '🥣 ఆరోగ్యకరమైన చిరుధాన్యాలు' }
  ],
  Arabic: [
    { value: 'balanced', label: '🍛 وجبات متوازنة يومية' },
    { value: 'high_protein', label: '🥗 بروتين عالي وألياف صحية' },
    { value: 'veg', label: '🥦 نباتي نقي 100%' },
    { value: 'non_veg', label: '🍗 وجبات غير نباتية مميزة' },
    { value: 'quick', label: '⚡ وجبات سريعة التحضير في 20 دقيقة' },
    { value: 'millets', label: '🥣 حبوب الدخن الصحية' }
  ]
};

// Rich Weekly Meal Plans generator
const MEAL_DATABASE = {
  English: {
    tamil: {
      balanced: [
        { day: "Monday", b: "Idli + Sambar + Coconut Chutney", l: "Sambar Rice + Potato Roast + Appalam", s: "Crispy Medu Vada + Filter Coffee", d: "Crispy Dosa + Tomato Chutney" },
        { day: "Tuesday", b: "Ven Pongal + Medu Vada + Sambar", l: "Arisi Paruppu Sadam + Potato Fry", s: "Chana Sundal + Masala Chai", d: "Soft Chapati + Paneer Butter Masala" },
        { day: "Wednesday", b: "Puffy Poori + Potato Masala", l: "Tomato Pepper Rasam Rice + Potato Fry", s: "Onion Pakoda + Hot Chai", d: "Veg Fried Rice + Gobi Manchurian" },
        { day: "Thursday", b: "Rava Upma + Coconut Chutney", l: "Nellai Sodhi + Rice + Potato Roast", s: "Kanda Poha + Sev + Lemon", d: "Malabar Parotta + Veg Kurma" },
        { day: "Friday", b: "Millet Pongal + Keerai Kootu", l: "Sambar Rice + Avial + Appalam", s: "Steamed Sweet Corn + Filter Coffee", d: "Curd Rice + Potato Fry + Pickle" },
        { day: "Saturday", b: "Aloo Paratha + Curd + Butter", l: "Vegetable Biryani + Onion Raita", s: "Sundal + Masala Tea", d: "Ghee Dosa + Kara Chutney" },
        { day: "Sunday", b: "Lacy Appam + Coconut Veg Stew", l: "Chettinad Pepper Chicken / Paneer Gravy", s: "Crispy Medu Vada + Tea", d: "Soft Wheat Phulkas + Dal Tadka" }
      ],
      high_protein: [
        { day: "Monday", b: "Pesarattu + Ginger Chutney", l: "Sambar Sadam + Boiled Eggs / Paneer", s: "Spiced Chana Sundal", d: "Paneer Bhurji + Whole Wheat Phulkas" },
        { day: "Tuesday", b: "Millet Pongal + Keerai Dal Kootu", l: "Kongu Dal Rice + Boiled Eggs / Tofu", s: "Roasted Gram & Green Tea", d: "Boiled Egg Pepper Masala + Chapati" },
        { day: "Wednesday", b: "Oats Upma + Boiled Sprouts", l: "Rajma Masala + Brown Rice", s: "Brown Chickpeas + Walnuts", d: "Chettinad Chicken Chukka / Soya Fry" },
        { day: "Thursday", b: "Steamed Idli + Heavy Dal Sambar", l: "Dal Tadka + Jeera Rice + Egg Fry", s: "Sprouted Moong Salad", d: "Paneer Capsicum + Phulka Rotis" },
        { day: "Friday", b: "Green Moong Dosa + Coconut Chutney", l: "Nellai Sodhi with Dal + Millets", s: "Fruit Bowl & Cashews", d: "Grilled Fish / Tofu Steak + Rice" },
        { day: "Saturday", b: "Egg Roast + Whole Wheat Bread", l: "Chicken Biryani + Boiled Egg + Raita", s: "Konda Kadalai Sundal", d: "Phulkas + Double Tadka Dal" },
        { day: "Sunday", b: "Whole Wheat Pooris + Chana Masala", l: "Fish Curry + Fish Fry + Steamed Rice", s: "Boiled Egg Slices + Pepper", d: "Paneer Tikka + Chapati" }
      ]
    },
    kerala: {
      balanced: [
        { day: "Monday", b: "Lacy Appam + Kerala Veg Stew", l: "Kerala Avial + Red Matta Rice + Moru Curry", s: "Parippu Vada + Black Tea", d: "Malabar Parotta + Veg Kurma" },
        { day: "Tuesday", b: "Steamed Puttu + Kadala Curry + Pappadam", l: "Sambar + Red Rice + Cabbage Thoran", s: "Banana Fritters (Pazham Pori) + Tea", d: "Soft Wheat Chapati + Egg Roast" },
        { day: "Wednesday", b: "Appam + Malabar Egg Roast", l: "Thengai Meen Kuzhambu + Matta Rice", s: "Unniyappam + Coffee", d: "Kerala Dosa + Coconut Chammanthi" },
        { day: "Thursday", b: "Idiyappam + Coconut Milk / Stew", l: "Moru Curry + Beans Thoran + Rice", s: "Sundal + Masala Chai", d: "Malabar Parotta + Chicken Salna" },
        { day: "Friday", b: "Puttu + Kadala Curry", l: "Authentic Avial + Matta Rice + Moru Curry", s: "Banana Chips + Tea", d: "Curd Rice + Pickle + Pappadam" },
        { day: "Saturday", b: "Appam + Veg Stew", l: "Malabar Dum Biryani + Date Pickle + Raita", s: "Parippu Vada + Chai", d: "Chapati + Paneer Curry" },
        { day: "Sunday", b: "Puttu + Steamed Banana + Pappadam", l: "Meen Pollichathu (Banana Leaf) + Rice", s: "Crispy Pakoda + Hot Tea", d: "Kerala Style Fried Rice + Gobi" }
      ]
    },
    andhra: {
      balanced: [
        { day: "Monday", b: "Crispy Green Moong Pesarattu + Allam Chutney", l: "Guntur Kodi Kura + Steamed Rice & Ghee", s: "Mirchi Bajji + Filter Coffee", d: "Phulka Chapati + Tomato Pappu" },
        { day: "Tuesday", b: "Steamed Idli + Andhra Gunpowder (Podi) & Ghee", l: "Tomato Pappu + Potato Roast + Rice", s: "Punugulu + Coconut Chutney", d: "Andhra Spicy Chicken Fry + Chapati" },
        { day: "Wednesday", b: "Rava Dosa + Allam Chutney", l: "Andhra Dal Tadka + Steamed Rice + Papad", s: "Onion Pakoda + Masala Chai", d: "Jeera Rice + Paneer Curry" },
        { day: "Thursday", b: "Upma + Pesarattu (MLA Pesarattu)", l: "Guntur Kodi Kura / Vegetable Biryani", s: "Chana Sundal + Tea", d: "Phulkas + Andhra Egg Curry" },
        { day: "Friday", b: "Soft Idlis + Andhra Tomato Kurma", l: "Gongura Pappu + Steamed Rice & Ghee", s: "Crispy Sev + Coffee", d: "Curd Rice + Mango Pickle" },
        { day: "Saturday", b: "Poori + Potato Masala", l: "Hyderabadi Chicken Biryani + Mirchi Ka Salan", s: "Masala Chai + Biscuits", d: "Chapati + Dal Fry" },
        { day: "Sunday", b: "Pesarattu + Ginger Chutney", l: "Andhra Fish Curry (Chepala Pulusu) + Rice", s: "Evening Bajji + Tea", d: "Phulkas + Paneer Butter Masala" }
      ]
    },
    north: {
      balanced: [
        { day: "Monday", b: "Aloo Paratha + Chilled Curd + Butter", l: "Punjabi Rajma Chawal + Kachumber Salad", s: "Samosa / Poha + Masala Chai", d: "Soft Phulka + Paneer Butter Masala" },
        { day: "Tuesday", b: "Paneer Stuffed Paratha + Mint Raita", l: "Dal Tadka + Jeera Rice + Aloo Gobi", s: "Roasted Peanuts & Tea", d: "Butter Chicken / Shahi Paneer + Naan" },
        { day: "Wednesday", b: "Kanda Poha + Sev + Lemon", l: "Chole Bhature + Pickled Green Chillies", s: "Crispy Onion Pakoda + Chai", d: "Phulkas + Yellow Moong Dal" },
        { day: "Thursday", b: "Gobhi Paratha + Fresh Butter", l: "Kadhi Pakora + Steamed Basmati Rice", s: "Biscuits + Cardamom Tea", d: "Paneer Bhurji + Whole Wheat Phulkas" },
        { day: "Friday", b: "Vegetable Oats Upma + Curd", l: "Dal Makhani + Jeera Rice + Roti", s: "Pav Bhaji + Butter Toasted Pav", d: "Khichdi + Ghee + Aloo Fry" },
        { day: "Saturday", b: "Chole Kulche + Pickled Onions", l: "Dum Biryani + Boondi Raita", s: "Dhokla + Green Chutney", d: "Chapati + Aloo Matar Sabzi" },
        { day: "Sunday", b: "Poori + Halwa + Chana", l: "Butter Chicken + Garlic Naan + Jeera Rice", s: "Kachori + Sweet Chai", d: "Phulkas + Dal Tadka" }
      ]
    }
  },
  Tamil: {
    tamil: {
      balanced: [
        { day: "Monday", b: "இட்லி + சாம்பார் + தேங்காய் சட்னி", l: "சாம்பார் சாதம் + உருளை வறுவல் + அப்பளம்", s: "மொறுமொறு மெது வடை + பில்டர் காபி", d: "மொறுமொறு தோசை + தக்காளி சட்னி" },
        { day: "Tuesday", b: "வெண் பொங்கல் + மெது வடை + சாம்பார்", l: "அரிசி பருப்பு சாதம் + உருளை வறுவல்", s: "சுண்டல் + மசாலா டீ", d: "சப்பாத்தி + பன்னீர் பட்டர் மசாலா" },
        { day: "Wednesday", b: "பூரி + உருளைக்கிழங்கு மசாலா", l: "ரசம் சாதம் + உருளை ஃப்ரை + அப்பளம்", s: "வெங்காய பக்கோடா + டீ", d: "வெஜ் ஃப்ரைட் ரைஸ் + கோபி மஞ்சூரியன்" },
        { day: "Thursday", b: "ரவா உப்புமா + தேங்காய் சட்னி", l: "திருநெல்வேலி சொதி + சாதம் + உருளை", s: "கெட்டி அவல் உப்புமா + எலுமிச்சை", d: "மலபார் பரோட்டா + வெஜ் குருமா" },
        { day: "Friday", b: "குதிரைவாலி பொங்கல் + கீரை கூட்டு", l: "சாம்பார் சாதம் + அவியல் + அப்பளம்", s: "சுண்டல் + பில்டர் காபி", d: "தயிர் சாதம் + உருளை ஃப்ரை + ஊறுகாய்" },
        { day: "Saturday", b: "ஆலூ பராத்தா + தயிர் + வெண்ணெய்", l: "சிக்கன் பிரியாணி / வெஜ் பிரியாணி + ராய்த்தா", s: "மும்பை பாவ் பாஜி + வெண்ணெய் பாவ்", d: "நெய் தோசை + கார சட்னி" },
        { day: "Sunday", b: "ஆப்பம் + கேரளா காய்கறி ஸ்டூ", l: "மீன் குழம்பு / செட்டிநாடு மிளகு சிக்கன்", s: "மெது வடை + சுடச்சுட டீ", d: "மெதுவான சப்பாத்தி + தால் தட்கா" }
      ],
      high_protein: [
        { day: "Monday", b: "பச்சை பயறு பெசரட்டு + இஞ்சி சட்னி", l: "சாம்பார் சாதம் + அவித்த முட்டை / பன்னீர்", s: "கொண்டைக்கடலை சுண்டல்", d: "பன்னீர் புர்ஜி + கோதுமை புல்கா" },
        { day: "Tuesday", b: "குதிரைவாலி பொங்கல் + கீரை கூட்டு", l: "கொங்கு பருப்பு சாதம் + முட்டை வறுவல்", s: "பொட்டுக்கடலை + கிரீன் டீ", d: "முட்டை மிளகு மசாலா + சப்பாத்தி" },
        { day: "Wednesday", b: "காய்கறி ஓட்ஸ் உப்புமா + சுண்டல்", l: "பஞ்சாபி ராஜ்மா சாதம் + சாலட்", s: "முளைகட்டிய பயறு சாலட்", d: "செட்டிநாடு சிக்கன் சுக்கா / சோயா வறுவல்" },
        { day: "Thursday", b: "மல்லிகைப் பூ இட்லி + திக்கான சாம்பார்", l: "தால் தட்கா + சீரக சாதம் + முட்டை", s: "முளைக்கட்டிய பாசிப்பயறு", d: "பன்னீர் குடைமிளகாய் + புல்கா ரொட்டி" },
        { day: "Friday", b: "பருப்பு தோசை + தேங்காய் சட்னி", l: "தேங்காய்ப்பால் சொதி + சிறுதானியம்", s: "பழங்கள் & வால்நட் முந்திரி", d: "மீன் வறுவல் + சுடு சோறு" },
        { day: "Saturday", b: "முட்டை ரோஸ்ட் + கோதுமை ரொட்டி", l: "சிக்கன் பிரியாணி + அவித்த முட்டை + ராய்த்தா", s: "கொண்டைக்கடலை மசாலா சுண்டல்", d: "புல்கா + தால் தட்கா பருப்பு" },
        { day: "Sunday", b: "கோதுமை பூரி + சென்னா மசாலா", l: "மதராஸ் மீன் குழம்பு + மீன் வறுவல் + சாதம்", s: "மிளகு முட்டை துண்டுகள்", d: "பன்னீர் டிக்கா + சப்பாத்தி" }
      ]
    },
    kerala: {
      balanced: [
        { day: "Monday", b: "ஆப்பம் + கேரளா காய்கறி ஸ்டூ", l: "கேரளா அவியல் + மட்ட அரிசி + மோர்க்குழம்பு", s: "பருப்பு வடை + பிளாக் டீ", d: "மலபார் பரோட்டா + வெஜ் குருமா" },
        { day: "Tuesday", b: "அரிசி புட்டு + கடலைக் கறி + அப்பளம்", l: "சாம்பார் + மட்ட அரிசி + முட்டைக்கோஸ் தோரன்", s: "பழம்பொரி (Pazham Pori) + டீ", d: "மெதுவான சப்பாத்தி + முட்டை ரோஸ்ட்" },
        { day: "Wednesday", b: "ஆப்பம் + மலபார் முட்டை ரோஸ்ட்", l: "தேங்காய் மீன் குழம்பு + மட்ட அரிசி", s: "உண்ணியப்பம் + காபி", d: "கேரளா தோசை + தேங்காய் சம்மந்தி" },
        { day: "Thursday", b: "இடியாப்பம் + தேங்காய்ப்பால் / ஸ்டூ", l: "மோர்க்குழம்பு + பீன்ஸ் தோரன் + சாதம்", s: "சுண்டல் + மசாலா டீ", d: "மலபார் பரோட்டா + சிக்கன் சால்னா" },
        { day: "Friday", b: "புட்டு + காரசார கடலைக் கறி", l: "பாரம்பரிய அவியல் + மட்ட சாதம் + மோர்க்குழம்பு", s: "நேந்திரம் சிப்ஸ் + டீ", d: "தயிர் சாதம் + ஊறுகாய் + அப்பளம்" },
        { day: "Saturday", b: "ஆப்பம் + வெஜிடபிள் ஸ்டூ", l: "தலச்சேரி பிரியாணி + ஈச்சங்காய் ஊறுகாய்", s: "பருப்பு வடை + டீ", d: "சப்பாத்தி + பன்னீர் கறி" },
        { day: "Sunday", b: "புட்டு + நேந்திரம்பழம் + அப்பளம்", l: "வாழை இலை மீன் பொள்ளிச்சது + சாதம்", s: "வெங்காய பக்கோடா + சுடச்சுட டீ", d: "கேரளா வெஜ் ஃப்ரைட் ரைஸ்" }
      ]
    },
    andhra: {
      balanced: [
        { day: "Monday", b: "ஆந்திரா பெசரட்டு + அல்லம் (இஞ்சி) சட்னி", l: "குண்டூர் சிக்கன் கறி + சுடு சோறு & நெய்", s: "மிர்ச்சி பஜ்ஜி + பில்டர் காபி", d: "புல்கா சப்பாத்தி + தக்காளி பப்பு" },
        { day: "Tuesday", b: "இட்லி + ஆந்திரா பருப்பு பொடி & நெய்", l: "தக்காளி பப்பு + உருளை வறுவல் + சாதம்", s: "புனுகுலு + தேங்காய் சட்னி", d: "ஆந்திரா கார சிக்கன் வறுவல் + சப்பாத்தி" },
        { day: "Wednesday", b: "ரவா தோசை + இஞ்சி சட்னி", l: "தால் தட்கா + சாதம் + அப்பளம்", s: "வெங்காய பக்கோடா + மசாலா டீ", d: "சீரக சாதம் + பன்னீர் கறி" },
        { day: "Thursday", b: "உப்புமா பெசரட்டு (MLA Pesarattu)", l: "குண்டூர் சிக்கன் / வெஜிடபிள் பிரியாணி", s: "கொண்டைக்கடலை சுண்டல் + டீ", d: "புல்கா + ஆந்திரா முட்டை கறி" },
        { day: "Friday", b: "மல்லிகைப் பூ இட்லி + தக்காளி குருமா", l: "கோங்குரா பப்பு + சாதம் & நெய்", s: "கார சேவ் + பில்டர் காபி", d: "தயிர் சாதம் + மாங்காய் ஊறுகாய்" },
        { day: "Saturday", b: "பூரி + உருளைக்கிழங்கு மசாலா", l: "ஹைதராபாத் சிக்கன் தம் பிரியாணி + மிர்ச்சி சலன்", s: "மசாலா டீ + பிஸ்கட்", d: "சப்பாத்தி + தால் ஃப்ரை" },
        { day: "Sunday", b: "பெசரட்டு + இஞ்சி சட்னி", l: "ஆந்திரா மீன் புலுசு + சாதம்", s: "மாலை நேர பஜ்ஜி + டீ", d: "புல்கா + பன்னீர் பட்டர் மசாலா" }
      ]
    },
    north: {
      balanced: [
        { day: "Monday", b: "ஆலூ பராத்தா + தயிர் + வெண்ணெய்", l: "பஞ்சாபி ராஜ்மா சாதம் + சாலட்", s: "சமோசா / அவல் + மசாலா டீ", d: "மெதுவான புல்கா + பன்னீர் பட்டர் மசாலா" },
        { day: "Tuesday", b: "பன்னீர் பராத்தா + புதினா ராய்த்தா", l: "தால் தட்கா + சீரக சாதம் + ஆலு கோபி", s: "வேர்க்கடலை + டீ", d: "பட்டர் சிக்கன் / ஷாஹி பன்னீர் + நான்" },
        { day: "Wednesday", b: "அவல் உப்புமா + எலுமிச்சை", l: "சோலே பட்டூரா + ஊறுகாய் பச்சை மிளகாய்", s: "வெங்காய பக்கோடா + டீ", d: "புல்கா + பாசிப்பருப்பு தால்" },
        { day: "Thursday", b: "கோபி பராத்தா + வெண்ணெய்", l: "கடி பக்கோடா + பாஸ்மதி சாதம்", s: "பிஸ்கட் + ஏலக்காய் டீ", d: "பன்னீர் புர்ஜி + கோதுமை புல்கா" },
        { day: "Friday", b: "காய்கறி ஓட்ஸ் உப்புமா + தயிர்", l: "தால் மக்கனி + சீரக சாதம் + ரொட்டி", s: "மும்பை பாவ் பாஜி + பட்டர் பாவ்", d: "கிச்சடி + நெய் + ஆலு ஃப்ரை" },
        { day: "Saturday", b: "சோலே குல்ச்சே + வெங்காய ஊறுகாய்", l: "தம் பிரியாணி + பூந்தி ராய்த்தா", s: "டோக்ளா + கிரீன் சட்னி", d: "சப்பாத்தி + ஆலு பட்டாணி மசாலா" },
        { day: "Sunday", b: "பூரி + அல்வா + சென்னா", l: "பட்டர் சிக்கன் + கார்லிக் நான் + சாதம்", s: "கச்சோரி + சுடச்சுட டீ", d: "புல்கா + தால் தட்கா" }
      ]
    }
  },
  Hindi: {
    tamil: {
      balanced: [
        { day: "Monday", b: "इडली + सांभर + नारियल चटनी", l: "सांभर चावल + आलू रोस्ट + पापड़", s: "कुरकुरा मेदू वड़ा + फ़िल्टर कॉफ़ी", d: "कुरकुरा डोसा + टमाटर चटनी" },
        { day: "Tuesday", b: "वेन पोंगल + मेदू वड़ा + सांभर", l: "दाल चावल + आलू फ्राई", s: "चना सुंडल + मसाला चाय", d: "चपाती + पनीर बटर मसाला" },
        { day: "Wednesday", b: "पूरी + आलू मसाला", l: "रसम चावल + आलू फ्राई + पापड़", s: "वेजिटेबल पकोड़ा + चाय", d: "वेज फ्राइड राइस + गोभी मंचूरियन" },
        { day: "Thursday", b: "रवा उपमा + नारियल चटनी", l: "नेल्लई सोधी + चावल + आलू रोस्ट", s: "कांदा पोहा + सेव + नींबू", d: "मालाबार परोटा + वेज कुरमा" },
        { day: "Friday", b: "मिलेट पोंगल + पालक का साग", l: "सांभर चावल + अवियल + पापड़", s: "उबला स्वीट कॉर्न + कॉफ़ी", d: "दही चावल + आलू फ्राई + अचार" },
        { day: "Saturday", b: "आलू पराठा + दही + मक्खन", l: "चिकन बिरयानी / वेज बिरयानी + रायता", s: "मुंबई पाव भाजी + बटर पाव", d: "घी डोसा + कारा चटनी" },
        { day: "Sunday", b: "अप्पम + केरल वेज स्टू", l: "मछली करी / चेट्टीनाड पेपर चिकन", s: "मेदू वड़ा + गरम चाय", d: "सॉफ्ट चपाती + दाल तड़का" }
      ]
    }
  }
};

export default function WeeklyPlanner({ t, lang }) {
  const [region, setRegion] = useState('tamil');
  const [diet, setDiet] = useState('balanced');

  const isEng = lang === 'English';
  const isHi = lang === 'Hindi';
  const isTa = lang === 'Tamil';
  const isTe = lang === 'Telugu';
  const isKn = lang === 'Kannada';
  const isMl = lang === 'Malayalam';
  const isAr = lang === 'Arabic';

  const currentLangKey = isHi ? 'Hindi' : (isTa ? 'Tamil' : (isTe ? 'Telugu' : (isAr ? 'Arabic' : 'English')));

  const regionList = REGION_OPTIONS[currentLangKey] || REGION_OPTIONS.English;
  const dietList = DIET_OPTIONS[currentLangKey] || DIET_OPTIONS.English;

  // Resolve plan
  const plansForLang = MEAL_DATABASE[currentLangKey] || MEAL_DATABASE.English;
  const fallbackLang = MEAL_DATABASE.English;

  const regionKey = plansForLang[region] ? region : (plansForLang.tamil ? 'tamil' : 'all');
  const regionBucket = plansForLang[regionKey] || fallbackLang.tamil;
  
  // Resolve plan array
  const plan = regionBucket[diet] || regionBucket.balanced || fallbackLang.tamil.balanced;

  const copyGroceryList = () => {
    const selectedRegionObj = regionList.find(r => r.value === region) || regionList[0];
    const selectedDietObj = dietList.find(d => d.value === diet) || dietList[0];

    let txt = '';
    if (isEng) {
      txt = `📅 MyMenuBuddy 7-Day Meal Plan (${selectedRegionObj.label} • ${selectedDietObj.label}):\n\n`;
    } else if (isHi) {
      txt = `📅 मायमेनुबडी 7-दिवसीय भोजन योजना (${selectedRegionObj.label} • ${selectedDietObj.label}):\n\n`;
    } else if (isTe) {
      txt = `📅 మైమెనూబడ్డీ 7 రోజుల భోజన ప్రణాళిక (${selectedRegionObj.label} • ${selectedDietObj.label}):\n\n`;
    } else if (isKn) {
      txt = `📅 MyMenuBuddy 7-ದಿನಗಳ ಊಟದ ಯೋಜನೆ (${selectedRegionObj.label} • ${selectedDietObj.label}):\n\n`;
    } else if (isMl) {
      txt = `📅 MyMenuBuddy 7-ദിവസത്തെ ഭക്ഷണ പ്ലാൻ (${selectedRegionObj.label} • ${selectedDietObj.label}):\n\n`;
    } else if (isAr) {
      txt = `📅 ماي منيو بودي جدول وجبات 7 أيام (${selectedRegionObj.label} • ${selectedDietObj.label}):\n\n`;
    } else {
      txt = `📅 மைமெனுபடி 7-நாள் உணவுத் திட்டம் (${selectedRegionObj.label} • ${selectedDietObj.label}):\n\n`;
    }

    plan.forEach(item => {
      const dayLabel = t.plannerDays?.[item.day] || item.day;
      const bSlot = t.plannerSlots?.b || 'Breakfast';
      const lSlot = t.plannerSlots?.l || 'Lunch';
      const sSlot = t.plannerSlots?.s || 'Snack';
      const dSlot = t.plannerSlots?.d || 'Dinner';
      txt += `${dayLabel}:\n• ${bSlot}: ${item.b}\n• ${lSlot}: ${item.l}\n• ${sSlot}: ${item.s}\n• ${dSlot}: ${item.d}\n\n`;
    });

    if (isEng) {
      txt += `🛒 Weekly Grocery Checklist (${selectedDietObj.label}):\n• Rice / Millets, Toor Dal, Moong Dal, Whole Wheat Atta\n• Potatoes, Onions, Tomatoes, Fresh Ginger, Garlic\n• Curry Leaves, Coriander, Green Chillies, Fresh Vegetables\n• Milk, Curd, Ghee, Cooking Oil & Spices`;
    } else if (isHi) {
      txt += `🛒 साप्ताहिक किराना सूची (${selectedDietObj.label}):\n• चावल / मिलेट्स, अरहर दाल, मूंग दाल, गेहूं का आटा\n• आलू, प्याज, टमाटर, ताजा अदरक, लहसुन\n• कढ़ी पत्ता, हरा धनिया, हरी मिर्च, ताजी सब्जियां\n• दूध, दही, शुद्ध घी, तेल और खड़े मसाले`;
    } else if (isTe) {
      txt += `🛒 వారపు కిరాణా సామాను లిస్ట్ (${selectedDietObj.label}):\n• బియ్యం / చిరుధాన్యాలు, కందిపప్పు, పెసరపప్పు, గోధుమ పిండి\n• బంగాళాదుంపలు, ఉల్లిపాయలు, టమోటాలు, అల్లం, వెల్లుల్లి\n• కరివేపాకు, కొత్తిమీర, పచ్చిమిర్చి, తాజా కూరగాయలు\n• పాలు, పెరుగు, స్వచ్ఛమైన నెయ్యి, నూనె & మసాలాలు`;
    } else if (isKn) {
      txt += `🛒 ವಾರದ ದಿನಸಿ ಸಾಮಗ್ರಿಗಳ ಪಟ್ಟಿ (${selectedDietObj.label}):\n• ಅಕ್ಕಿ / ಸಿರಿಧಾನ್ಯ, ತೊಗರಿ ಬೇಳೆ, ಹೆಸರು ಬೇಳೆ, ಗೋಧಿ ಹಿಟ್ಟು\n• ಆಲೂಗಡ್ಡೆ, ಈರುಳ್ಳಿ, ಟೊಮೆಟೊ, ಶುಂಠಿ, ಬೆಳ್ಳುಳ್ಳಿ\n• ಕರಿಬೇವಿನ ಸೊಪ್ಪು, ಕೊತ್ತಂಬರಿ, ಹಸಿಮೆಣಸಿನಕಾಯಿ, ತಾಜಾ ತರಕಾರಿಗಳು\n• ಹಾಲು, ಮೊಸರು, ತುಪ್ಪ, ಎಣ್ಣೆ ಮತ್ತು ಸಾಂಬಾರ ಪದಾರ್ಥಗಳು`;
    } else if (isMl) {
      txt += `🛒 പ്രതിവാര പലചരക്ക് സാധനങ്ങളുടെ ലിസ്റ്റ് (${selectedDietObj.label}):\n• അരി / ചെറുധാന്യങ്ങൾ, തുവരപ്പരിപ്പ്, ചെറുപയർ പരിപ്പ്, ഗോതമ്പ് പൊടി\n• ഉരുളക്കിഴങ്ങ്, ഉള്ളി, തക്കാളി, ഇഞ്ചി, വെളുത്തുള്ളി\n• കറിവേപ്പില, മല്ലിയില, പച്ചമുളക്, പുതിയ പച്ചക്കറികൾ\n• പാൽ, തൈര്, നെയ്യ്, വെളിച്ചെണ്ണ & മസാലക്കൂട്ടുകൾ`;
    } else if (isAr) {
      txt += `🛒 قائمة مقاضي البقالة الأسبوعية (${selectedDietObj.label}):\n• أرز / دخن، عدس أصفر، عدس ماش، دقيق قمح كامل\n• بطاطس، بصل، طماطم، زنجبيل طازج، ثوم\n• أوراق كاري، كزبرة، فلفل أخضر، خضار طازجة مشكلة\n• حليب، زبادي، سمن بلدي نقي، زيت طبخ وبهارات كاملة`;
    } else {
      txt += `🛒 வாராந்திர மளிகைப் பட்டியல் (${selectedDietObj.label}):\n• புழுங்கல் அரிசி / பச்சரிசி / சிறுதானியம், துவரம் பருப்பு, பாசிப்பருப்பு, கோதுமை மாவு\n• உருளைக்கிழங்கு, வெங்காயம், தக்காளி, இஞ்சி, பூண்டு\n• கறிவேப்பிலை, கொத்தமல்லி, பச்சை மிளகாய், சமையல் காய்கறிகள்\n• பால், தயிர், சுத்தமான நெய், நல்லெண்ணெய் & மசாலாக்கள்`;
    }

    navigator.clipboard?.writeText(txt);
    alert(t.plannerCopiedAlert || 'Weekly checklist copied to clipboard!');
  };

  return (
    <section id="plannerSection" className="section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">{t.navPlanner}</span>
          <h2 className="section-title">{t.plannerTitle}</h2>
          <p className="section-desc">{t.plannerSubtitle}</p>
        </div>

        {/* Dynamic State & Diet Dropdown Filter Bar */}
        <div className="planner-controls-box">
          <div className="planner-dropdown-group">
            {/* 1. Regional Cuisine Dropdown */}
            <div className="planner-dropdown-item">
              <label className="planner-dropdown-label">
                <span className="label-icon">📍</span>
                <span>{isTa ? 'மாநிலம் / உணவுப் பாணி:' : (isHi ? 'राज्य / खानपान:' : (isTe ? 'ప్రాంతం / వంటల శైలి:' : (isKn ? 'ರಾಜ್ಯ / ಆಹಾರ ಶೈಲಿ:' : (isMl ? 'സംസ്ഥാനം / ഭക്ഷണ ശൈലി:' : (isAr ? 'المنطقة / نوع المطبخ:' : 'State & Regional Cuisine:')))))}</span>
              </label>
              <select
                className="planner-select"
                value={region}
                onChange={(e) => setRegion(e.target.value)}
              >
                {regionList.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>

            {/* 2. Diet & Health Goal Dropdown */}
            <div className="planner-dropdown-item">
              <label className="planner-dropdown-label">
                <span className="label-icon">🥗</span>
                <span>{isTa ? 'டயட் & உணவு வகை:' : (isHi ? 'डाइट व खानपान:' : (isTe ? 'ఆహార ప్రాధాన్యత / లక్ష్యం:' : (isKn ? 'ಆಹಾರ ಪದ್ಧತಿ & ಗುರಿ:' : (isMl ? 'ഭക്ഷണരീതി & ലക്ഷ്യം:' : (isAr ? 'النظام الغذائي / الهدف الصحي:' : 'Diet & Health Goal:')))))}</span>
              </label>
              <select
                className="planner-select"
                value={diet}
                onChange={(e) => setDiet(e.target.value)}
              >
                {dietList.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          </div>

          <button type="button" className="btn btn-primary planner-copy-btn" onClick={copyGroceryList}>
            <span>📋</span>
            <span>{t.plannerBtnCopy}</span>
          </button>
        </div>

        {/* 7-Day Interactive Meal Grid */}
        <div className="weekly-grid">
          {plan.map(item => {
            const dayLabel = t.plannerDays[item.day] || item.day;

            return (
              <div key={item.day} className="weekly-day-card">
                <div className="weekly-day-header">
                  <h4>{dayLabel}</h4>
                </div>
                <div className="weekly-day-body">
                  <div className="meal-slot">
                    <span className="slot-badge slot-b">{t.plannerSlots.b}</span>
                    <span className="slot-dish">{item.b}</span>
                  </div>
                  <div className="meal-slot">
                    <span className="slot-badge slot-l">{t.plannerSlots.l}</span>
                    <span className="slot-dish">{item.l}</span>
                  </div>
                  <div className="meal-slot">
                    <span className="slot-badge slot-s">{t.plannerSlots.s}</span>
                    <span className="slot-dish">{item.s}</span>
                  </div>
                  <div className="meal-slot">
                    <span className="slot-badge slot-d">{t.plannerSlots.d}</span>
                    <span className="slot-dish">{item.d}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
